// extracted by mini-css-extract-plugin
export default {"rule-definition":"styles_rule-definition__nXt75","bolded":"styles_bolded__74uyT"};